import { Component, OnInit, ChangeDetectorRef, OnChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { BasePageComponent } from '../base-page/base-page.component';
import { LabelP, HomescreenVodsP, CategoryP, ContentP, HomescreenVodsOpt } from '../../../data/cms-vod-client-api';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';
import { DataSharingService } from '../../../core/data-sharing/data-sharing.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { CategoryItem } from '../../../data/vod/models/category-item';
import { PodcastDataRestService } from '../../../data/podcast/podcast-data-rest.service';
import { PodcastGroup } from '../../../data/podcast-client-api/model/podcastContent';
import { ContentListResponse } from '../../../data/cms-vod-client-api/model/contentListResponses';
import { SeoService } from '../../../data/seo/seo-service.service';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { getCarouselIndex, setCarouselIndex } from '../../../data/config';
import { BlogDataRestService } from '../../../data/blog/blog-data-rest.service';
import { PostGroupP } from '../../../data/blog-client-api';

declare var videojs: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BasePageComponent implements OnInit, OnDestroy, AfterViewInit {
  // categories: LabelP[] = [];
  homeScreenVods: HomescreenVodsOpt[] = [];
  homeScreenVodsTemp: HomescreenVodsOpt[] = [];
  selectedCarouselID: string = null;
  selectedContentID: string = null;
  carouselStatic: string = 'video-carousel-';
  routerSubs: Subscription
  categoryID: number;
  categories: CategoryP[] = [];
  mainBoardContents: ContentListResponse[] = [];
  podcastGroups: PodcastGroup[] = [];
  blogGroups: PostGroupP[] = [];
  isLast: boolean;
  isLastPodcast: boolean;
  loadingMbi: boolean = true;
  loadingHomeVods: boolean = true;
  index: number = 0;
  labelCount: number = 5;
  eventListener: EventListener;
  scrollHandler: any;
  isDesktop: boolean;
  scrollHeigth: number;
  isInitialized: boolean;

  constructor(helpers: HelpersService,
    private vodService: VodDataRestService,
    private dataSharing: DataSharingService,
    private route: ActivatedRoute,
    private router: Router,
    private cd: ChangeDetectorRef,
    private podcastService: PodcastDataRestService,
    private seo: SeoService,
    private dataPipe: DatePipe,
    private deviceService: DeviceDetectorService,
    private blogService: BlogDataRestService,
  ) {
    super(helpers);
    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return false;
    // };
    this.isDesktop = deviceService.isDesktop();

    if (this.isDesktop) {
      this.scrollHeigth = 200;
    }
    else {
      this.scrollHeigth = 100;
    }

    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        // this.router.navigated = false;
        this.categoryID = +this.route.snapshot.paramMap.get('id');
        this.index = 0;
        this.i = 1;
        if (this.homeScreenVods != null) {
          this.loadingMbi = true;
          this.loadingHomeVods = true;
          this.homeScreenVods = [];
          this.mainBoardContents = [];
          this.podcastGroups = [];
          // this.removeListener();
          // this.activateListener();
          this.isInitialized = true;
          this.getDatas();
        }

      }
    });

    // this.getHomeScreenLabels();
    this.categoryID = +this.route.snapshot.paramMap.get('id');

    dataSharing.carouselID$.subscribe(data => {
      if (data && this.router.url.includes('dashboard')) {
        if (this.selectedCarouselID != null && (this.selectedCarouselID != data.carouselID)) {
          let detailClass = document.getElementById(this.selectedCarouselID)
          // let img = document.getElementById(this.selectedContent.id + '')
          let selectedItem = document.getElementById(this.selectedCarouselID + '' + this.selectedContentID)
          // img.style.visibility = 'hidden';
          selectedItem.classList.remove('selected');

          detailClass.classList.remove('accordion-opened');
          // this.dataSharing.sendCloseCarouse(data);
        }

        this.selectedCarouselID = data.carouselID;
        this.selectedContentID = data.contentID;

      }
    })

  }

  ngOnInit() {

    this.seo.generateTags({
      title: 'sportstv',
      description: 'sportstv Platform, sporun her branşını kapsayan yayıncılık anlayışıyla hareket eden bir premium içerik yaratıcısı; geliştiricisi; sağlayıcısı olmakla birlikte kapsamlı bir OTT platformudur. ',
      image: 'assets/images/template/platform-logo.png',
      slug: 'dashboard',
      url: this.router.url,

    });
    
    if (!this.isInitialized) {
      this.getDatas();
    }
    // this.vodService.getActiveCategories().subscribe(data => {
    //   this.categories = data;

    //   console.log("find : ",this.categories.findIndex(item => item.main == true));

    //   this.categoryID = this.categories.find(item => item.main == true).id
    //   this.getHomeScreenVods();

    // })
    // var player = videojs('vid1');
    // player.play();
  }

  ngAfterViewInit() {

  }

  activateListener() {
    this.scrollHandler = this.scrolling.bind(this);
    window.addEventListener("scroll", this.scrollHandler)

    // window.addEventListener("scroll", function () { // or window.addEventListener("scroll"....

    // }, false);
  }

  i: number = 1;
  scrolling() {
    var lastScrollTop = 0;

    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop) {
      // downscroll code
      // if (thiz.index == 5) {
      //   thiz.index = 5;
      // }
      if (window.pageYOffset > (this.scrollHeigth * this.i)) {
        ++this.i;
        this.loadHomeVods(1);
      }

    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling


  }

  // getHomeScreenLabels() {
  //   this.vodService.getHomeScreenLabels().subscribe(data => {
  //     this.categories = data;
  //   });
  // }

  getDatas() {
    
    //Podcast farklı bir servisten çekileceği için bu kontrol yapılmalıdır.
    if (this.categoryID == -1) {
      this.getPodcastGroups();
      this.homeScreenVods = [];
      this.mainBoardContents = [];
    }
    else if (this.categoryID == -2) {
      this.getBlogGroups();
      this.homeScreenVods = [];
      this.mainBoardContents = [];
    } else {
      this.getMainboardContents();
      this.getHomeScreenVods();
    }
  }

  getPodcastGroups() {
    this.podcastService.getPodcastGroups().subscribe(data => {
      this.podcastGroups = data;
      this.loadingMbi = false;
      this.loadingHomeVods = false;
    })
  }

  getBlogGroups() {
    this.blogService.getBlogGroups().subscribe(data => {
      console.log("data: ", data);
      
      this.blogGroups = data;
      console.log("categoryID: ", this.categoryID);
      console.log("blogGroups: ", this.blogGroups);
      
      this.loadingMbi = false;
      this.loadingHomeVods = false;
    })
  }

  getMainboardContents() {
    this.vodService.getMainContents(this.categoryID).subscribe(response => {
      if (response) {
        this.mainBoardContents = response;
        this.cd.detectChanges();
        this.loadingMbi = false;
      }
    });
  }

  getHomeScreenVods() {
    this.vodService.getHomeScreenVods(this.categoryID ? this.categoryID : null).subscribe(data => {
      if (data) {
        this.homeScreenVodsTemp = data;
        if (getCarouselIndex() && getCarouselIndex()>this.labelCount) {
          this.loadHomeVods(getCarouselIndex() + 1);
        }else {
          this.loadHomeVods(this.labelCount);
        }
        this.loadingHomeVods = false;
        console.log("gethomescrreenvods getCarouselIndex:", getCarouselIndex());
        
        if (getCarouselIndex()) {
          setTimeout(() => {
            console.log("gethomescrreenvods el",document.getElementById("video-carousel-"+getCarouselIndex()));
            
            document.getElementById("video-carousel-"+getCarouselIndex()).scrollIntoView({block: "center"})
            setCarouselIndex(0);
          }, 100);
        }
      }
    })
  }

  loadHomeVods(count: number) {
    this.homeScreenVods.push.apply(this.homeScreenVods, this.homeScreenVodsTemp.slice(this.index, this.index + count));
    this.index += count;
    this.removeListener();
    this.activateListener();
    if (this.homeScreenVodsTemp.length == this.homeScreenVods.length && !!this.homeScreenVods.length) {
      this.removeListener();
    }
  }


  ngOnDestroy() {
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
      this.routerSubs = null;
    }
    this.removeListener();
  }

  removeListener() {
    window.removeEventListener("scroll", this.scrollHandler)

  }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/commons/dashboard/dashboard.component.ts